/*
* @Author: Irem Ercan
* @Date:   2018-01-29 15:56:05
* @Last Modified by:   Irem Ercan
* @Last Modified time: 2018-01-29 16:27:50
*/

import Slider from './slider';

class EmojiSlider {
  constructor(params) {
    this.container = params.cardContainer;
    this.scaleItem = this.container.querySelector('.js-emojiSlider');

    this.slider = new Slider({
      qid: params?.question?.id,
      options: this.sliderOptions,
      container: this.scaleItem
    });
  }

  get sliderOptions() {
    return {
      rowSelector: '.js-emojiScale',
      labelSelector: '.js-emojiFaces',
      rangeSelector: '.js-emojiSlider-faceList',
      scaleSeperatorSelector: '.js-emojiScaleSep',
      visibleClass: 'isVisible',
      transitionClass: 'hasTransition',
      filledClass: 'isFilled',
      scaleListItemSelector: '.js-emojiSlider'
    };
  }
}

export default EmojiSlider;
